import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import { FormikProps, getIn } from "formik";
import _ from "lodash";

import InputAdornment from "components/InputAdornment";
import TextField from "components/TextField";

import { ITransactionValuesForm } from "entities/Deal/sdk";

export interface ITransactionTextField {
  formik: FormikProps<ITransactionValuesForm>;
  fieldName: string;
  label: string;
  disabled?: boolean;
  showDollarSign?: boolean;
  sx?: SxProps<Theme>;
  multiline?: boolean;
  rows?: number;
  isNumber?: boolean;
}

const TransactionTextField = ({
  formik,
  fieldName,
  label,
  rows,
  sx,
  disabled = false,
  showDollarSign = false,
  multiline = false,
  isNumber = false,
}: ITransactionTextField) => (
  <TextField
    sx={{ ...sx }}
    {...formik.getFieldProps(fieldName)}
    InputProps={{
      startAdornment: showDollarSign && (
        <InputAdornment position="start">$</InputAdornment>
      ),
    }}
    InputLabelProps={{ shrink: true }}
    label={label}
    error={
      getIn(formik.touched, fieldName) &&
      !_.isNil(getIn(formik.errors, fieldName))
    }
    helperText={
      getIn(formik.touched, fieldName) &&
      !_.isNil(getIn(formik.errors, fieldName)) &&
      getIn(formik.errors, fieldName)
    }
    disabled={disabled}
    multiline={multiline}
    rows={rows}
    type={isNumber ? "number" : "text"}
  />
);

export default TransactionTextField;
